/* Lexuma Global (www.lexuma.com) — order tracking page.
   Same JSON contract as the Gadgeticloud / SVICLOUD pages (7 states). English only. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lx-track]');
  if (!root) return;

  var WEBHOOK = root.getAttribute('data-webhook-url');
  var SITEKEY = root.getAttribute('data-turnstile-sitekey');
  var form = root.querySelector('#lx-form');
  var out = root.querySelector('#lx-result');
  var btn = root.querySelector('#lx-submit');
  var tsHost = root.querySelector('#lx-turnstile');
  var tsWidget = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return String(iso);
    return d.toLocaleString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  }

  /* ── Turnstile ──────────────────────────────────────────────────────────
     Hardened 2026-09-28 after a buyer-side "keeps spinning" report (Cloudflare analytics:
     24 challenges issued / 1 solved in 15 min for one visitor). Turnstile's defaults retry
     every 8s with no feedback, so a stuck widget looked dead. Now: 2.5s retries, auto refresh
     on expiry/timeout, token taken from the success callback, and a 15s watchdog that offers
     a restart and shows Turnstile's error code (so a report can be diagnosed). */
  var tsToken = '', tsErrors = 0, tsCode = '', tsWatch = null;
  var tsNote = document.createElement('div');
  tsNote.className = 'lx-ts-note'; tsNote.setAttribute('role', 'status'); tsNote.hidden = true;
  tsHost.parentNode.insertBefore(tsNote, tsHost.nextSibling);

  function tsStatus(html) { tsNote.innerHTML = html || ''; tsNote.hidden = !html; }
  function tsExplain() {
    var restart = '<button type="button" class="lx-ts-note__btn" data-ts-restart>Restart verification</button>';
    var code = tsCode;
    tsStatus(tsErrors ? ('Verification could not complete' + (code ? ' (code ' + esc(code) + ')' : '') + '. ' + restart + '<br><span>If it keeps failing, pause your VPN or ad-blocker, or try another browser.</span>') : ('Verification is taking longer than usual. ' + restart + '<br><span>If it keeps spinning, pause your VPN or ad-blocker, or try another browser.</span>'));
  }
  function tsArm() {
    clearTimeout(tsWatch);
    tsWatch = setTimeout(function () { if (!tsToken) tsExplain(); }, 15000);
  }
  function tsRestart() {
    tsToken = ''; tsErrors = 0; tsCode = ''; tsStatus('');
    if (window.turnstile && tsWidget !== null) { try { window.turnstile.reset(tsWidget); } catch (e) {} }
    tsArm();
  }
  tsNote.addEventListener('click', function (e) {
    if (e.target && e.target.hasAttribute('data-ts-restart')) tsRestart();
  });

  /* Turnstile is loaded lazily; the callback name is global by necessity. */
  window.lxTurnstileReady = function () {
    if (!SITEKEY || !window.turnstile || tsWidget !== null) return;
    tsWidget = window.turnstile.render(tsHost, {
      sitekey: SITEKEY, theme: 'light',
      retry: 'auto', 'retry-interval': 2500,
      'refresh-expired': 'auto', 'refresh-timeout': 'auto',
      callback: function (t) { tsToken = t || ''; tsErrors = 0; tsCode = ''; clearTimeout(tsWatch); tsStatus(''); },
      'expired-callback': function () { tsToken = ''; tsArm(); },
      'timeout-callback': function () { tsToken = ''; tsArm(); },
      /* A checkbox is waiting for the buyer: that is not "stuck", so pause the watchdog. */
      'before-interactive-callback': function () { clearTimeout(tsWatch); tsStatus(''); },
      'after-interactive-callback': function () { tsArm(); },
      'error-callback': function (code) {
        tsToken = ''; tsErrors++; tsCode = String(code || '');
        if (window.console) console.warn('[turnstile] error', tsCode);
        if (tsErrors >= 3) tsExplain();
        /* returning nothing keeps Turnstile's own retry loop running */
      }
    });
    tsArm();
  };
  (function loadTurnstile() {
    if (!SITEKEY) return;
    if (window.turnstile) { window.lxTurnstileReady(); return; }
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=lxTurnstileReady&render=explicit';
    s.async = true; s.defer = true;
    document.head.appendChild(s);
  })();

  var STATE_PILL = {
    delivered:   ['lx-pill--ok',  'Delivered'],
    in_transit:  ['lx-pill--live', 'In transit'],
    exception:   ['lx-pill--stop', 'Action needed'],
    awaiting_dispatch: ['lx-pill--warn', 'Preparing']
  };

  function progressPct(state, cps) {
    if (state === 'delivered') return 100;
    if (state === 'awaiting_dispatch') return 8;
    if (!cps || !cps.length) return 20;
    return Math.min(85, 25 + cps.length * 12);
  }

  function renderSkeleton() {
    out.innerHTML = '<div class="lx-skel"><div style="width:45%"></div>' +
      '<div style="width:80%"></div><div style="width:65%"></div><div style="width:72%"></div></div>';
  }

  function note(kind, title, extra) {
    return '<div class="lx-note ' + (kind ? 'lx-note--' + kind : '') + '">' +
      '<h3>' + title + '</h3>' + (extra || '') + '</div>';
  }

  var HELP = '<p>Need help? <a href="/pages/contact-us">Contact us</a> or email ' +
             '<a href="mailto:shop@lexuma.com">shop@lexuma.com</a> and we will look it up for you.</p>';

  function renderError(state) {
    if (state === 'not_found') {
      out.innerHTML = note('warn', 'We could not find an order matching those details.',
        '<p>Check the order number exactly matches your confirmation email, and that the email is the one used at checkout.</p>' + HELP);
    } else if (state === 'invalid_input') {
      out.innerHTML = note('warn', 'Please check what you entered.',
        '<p>Order number and email are both required, and the verification must complete.</p>');
    } else {
      out.innerHTML = note('stop', 'Tracking is temporarily unavailable.',
        '<p>The tracking service did not respond. Please try again shortly.</p>' + HELP);
    }
  }

  function orderHead(o, pillCls, pillText) {
    return '<div class="lx-card__head">' +
      '<div><div class="lx-card__order">' + esc(o.name || '') + '</div>' +
      '<div class="lx-card__meta">Ordered ' + fmtDate(o.created_at) + '</div></div>' +
      '<span class="lx-pill ' + pillCls + '">' + pillText + '</span></div>';
  }

  function renderAwaiting(res) {
    var o = res.order || {};
    out.innerHTML =
      '<div class="lx-card">' + orderHead(o, 'lx-pill--warn', 'Preparing') +
      '<div class="lx-card__body">' + itemsHtml(o) +
        '<div class="lx-bar"><div class="lx-bar__fill" style="width:8%"></div></div>' +
      '</div></div>' +
      note('', 'Your order is confirmed and being prepared.',
        '<p>You will get an email with your tracking number as soon as it ships. Come back here any time to follow it.</p>');
  }

  function itemsHtml(o) {
    var li = (o.line_items || []).map(function (i) {
      return '<li>' + esc(i.title) + ' × ' + esc(i.quantity) + '</li>';
    }).join('');
    return li ? '<ul class="lx-items">' + li + '</ul>' : '';
  }

  function shipmentHtml(s, state) {
    var cps = (s.checkpoints || []).slice().sort(function (a, b) {
      return new Date(b.datetime || 0) - new Date(a.datetime || 0);
    });
    var tl = cps.map(function (c, i) {
      var cls = i === 0 ? 'is-latest' : 'is-done';
      return '<li class="' + cls + '">' +
        '<div class="lx-tl__time">' + fmtDate(c.datetime) + '</div>' +
        '<div class="lx-tl__msg">' + esc(c.message || '') + '</div>' +
        (c.location ? '<div class="lx-tl__loc">' + esc(c.location) + '</div>' : '') +
        '</li>';
    }).join('');

    var eta = '';
    if (state === 'delivered' && s.shipment_delivery_date) {
      eta = '<div class="lx-ship__eta">Delivered '  + fmtDate(s.shipment_delivery_date) + '</div>';
    } else if (s.expected_delivery) {
      eta = '<div class="lx-ship__eta">Estimated delivery '  + fmtDate(s.expected_delivery) + '</div>';
    }

    return '<div class="lx-ship">' +
      '<div class="lx-ship__head"><span class="lx-ship__carrier">' + esc(s.carrier || 'Carrier') + '</span>' +
      (s.tracking_number ? '<span class="lx-ship__num">' + esc(s.tracking_number) + '</span>' : '') +
      '</div>' + eta +
      (s.carrier_message ? '<div class="lx-ship__msg">' + esc(s.carrier_message) + '</div>' : '') +
      '<div class="lx-bar"><div class="lx-bar__fill" style="width:' + progressPct(state, cps) + '%"></div></div>' +
      (tl ? '<ul class="lx-tl">' + tl + '</ul>' : '') +
      (s.tracking_url ? '<a class="lx-ship__link" href="' + esc(s.tracking_url) +
        '" target="_blank" rel="noopener">View on carrier site →</a>' : '') +
      '</div>';
  }

  function renderTimeline(res) {
    var o = res.order || {};
    var pill = STATE_PILL[res.state] || STATE_PILL.in_transit;
    var ships = (res.shipments || []).map(function (s) { return shipmentHtml(s, res.state); }).join('');
    out.innerHTML =
      '<div class="lx-card">' + orderHead(o, pill[0], pill[1]) +
      '<div class="lx-card__body">' + itemsHtml(o) + ships + '</div></div>' +
      (res.state === 'exception'
        ? note('warn', 'This shipment needs attention.',
            '<p><a href="/pages/contact-us">Contact us</a> and we will chase the carrier for you.</p>')
        : '');
  }

  function render(res) {
    switch (res.state) {
      case 'in_transit':
      case 'delivered':
      case 'exception': return renderTimeline(res);
      case 'awaiting_dispatch': return renderAwaiting(res);
      default: return renderError(res.state);
    }
  }

  var orderInput = form.querySelector('#lx-order');
  /* Put the second "-" in the field for the buyer: after 3 letters the dash appears, so the
     field reads SIWB-XXX-… and the remaining part is obvious. Only on forward typing, so
     Backspace can still delete the dash. */
  orderInput.addEventListener('input', function (e) {
    var v = orderInput.value.toUpperCase();
    var m = v.match(/^([A-Z]{3})(\d.*)$/);          /* pasted/typed "RET1310" → "RET-1310" */
    if (m) v = m[1] + '-' + m[2];
    if (/^[A-Z]{3}$/.test(v) && (!e || !e.inputType || e.inputType.indexOf('insert') === 0)) v += '-';
    if (v !== orderInput.value) orderInput.value = v;
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    /* The field shows a fixed "SIWB-" affix and takes the rest (e.g. RET-1310). A buyer who
       pastes the WHOLE number would otherwise submit a doubled prefix, so strip it first.
       Legacy PIWB-… numbers are sent as typed. The backend normalises spacing/dashes too. */
    var typed = (form.querySelector('#lx-order').value || '').trim().toUpperCase().replace(/^#/, '');
    var order = !typed ? '' : /^PIWB/.test(typed) ? typed : 'SIWB-' + typed.replace(/^SIWB[\s\-_]*/, '');
    var email = (form.querySelector('#lx-email').value || '').trim();
    /* A bare "1310" is not accepted — the buyer must enter the full number from the email. */
    if (typed && !/^[SP]IWB[\s\-_]*[A-Z]{3}[\s\-_]*\d{3,8}$/.test(order)) {
      out.innerHTML = note('warn', 'Please enter your full order number.',
        '<p>Copy it exactly as shown in your order confirmation email, in the format <strong>SIWB-XXX-XXXX</strong>.</p>');
      orderInput.focus();
      return;
    }
    if (!order || !email) { renderError('invalid_input'); return; }

    var token = '';
    if (SITEKEY) {
      token = tsToken || (window.turnstile && tsWidget !== null ? (window.turnstile.getResponse(tsWidget) || '') : '');
      if (!token) {
        out.innerHTML = note('warn', 'Please complete the verification first.', '');
        tsExplain();
        return;
      }
    }

    btn.disabled = true;
    renderSkeleton();

    fetch(WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_number: order, email: email, turnstile_token: token })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { render(res || { state: 'network_error' }); })
      .catch(function () { renderError('network_error'); })
      .finally(function () {
        btn.disabled = false;
        /* A Turnstile token is single-use — without a reset the second lookup always fails. */
        tsRestart();
      });
  });
})();
